"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._putSimulationSettings = exports._postSimulationSettings = exports._getSimulationSetting = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const _getSimulationSetting = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/setting';
    const config = {
        params: {
            skip: 0,
            take: 1,
            sort: JSON.stringify([{ field: 'modified_date', dir: 'desc' }]),
            filter: JSON.stringify({
                'logic': 'and',
                'filters': [
                    { field: 'is_active', operator: 'eq', value: true },
                ]
            })
        },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            data: [],
            countData: 0,
            isError: true,
            errorCode: err.errorCode,
            errorMessage: err.errorMessage,
        };
    }
});
exports._getSimulationSetting = _getSimulationSetting;
const _postSimulationSettings = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/setting';
    try {
        const resposne = yield axios_1.default.post(url, payload, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: resposne.data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports._postSimulationSettings = _postSimulationSettings;
const _putSimulationSettings = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/transaction/setting/${arg.id}`;
    try {
        const payload = {
            hauling: arg.hauling,
            production: arg.production,
            bg_loading: arg.bg_loading,
            simulation_assumption: arg.simulation_assumption,
        };
        const resposne = yield axios_1.default.put(url, payload, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: resposne.data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports._putSimulationSettings = _putSimulationSettings;
